import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Feature rings control which users get access to pre-release features. <strong>Select a ring</strong> to view and manage its members." id="feature_rings_control_which_users_get_ac.74bb6b83" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Early Access Rings" id="early_access_rings.f23fa6fd" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Search for users and <strong>assign</strong> them to a feature ring. Once added, they will have access to features enabled for that ring." id="search_for_users_and_assign_them_to_a_fe.941a996e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Adding Users" id="adding_users.ee22314d" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="<strong>Remove</strong> a user from a ring to revoke their access to pre-release features. They will return to the default (Public) experience." id="remove_a_user_from_a_ring_to_revoke_thei.edded6ac" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Removing Users" id="removing_users.5403fa28" />
        }
    ],
    title: <FormattedMessage defaultMessage="Feature Ring Manager" id="feature_ring_manager.94caf8a7" />
};
